import React from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import { SbSharedRefineMenuColorSelect } from '../SbSharedRefineMenuColorSelect/SbSharedRefineMenuColorSelect';

export const SbSharedRefineMenuFilterColorComponent = props => (
    <SbSharedRefineMenuColorSelect {...props} />
);

export const SbSharedRefineMenuFilterColor = createFragmentContainer(
    SbSharedRefineMenuFilterColorComponent,
    {
        searchBrowse: graphql`
            fragment SbSharedRefineMenuFilterColor_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuColorSelect_searchBrowse
            }
        `,
    }
);
